import React, { useState, useEffect, useRef } from "react";
import styles from "../styles/PlayersModal.module.css";
import cross from '../images/cross.svg';
import { getPlayerById } from "@/widgets/formSection/api/formApi.js";

export default function PlayerInput({ value, onChange, onRemove }) {
    const [searchResults, setSearchResults] = useState([]);
    const [displayValue, setDisplayValue] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const wrapperRef = useRef(null);

    const unregPlayer = { id: -1, fio: "Гость" };

    // Клик вне списка — закрыть
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Поиск игрока
    const searchPlayers = async (id) => {
        if (!id.trim()) {
            setSearchResults([unregPlayer]);
            return;
        }
        try {
            const result = await getPlayerById(parseInt(id));
            const res = result.data;
            let players = Array.isArray(res) && res.length ? res : [];
            players.unshift(unregPlayer);
            setSearchResults(players);
            setIsOpen(true);
        } catch {
            setSearchResults([unregPlayer]);
            setIsOpen(true);
        }
    };

    // Debounce поиск
    useEffect(() => {
        if (!displayValue || isNaN(displayValue)) {
            setSearchResults([unregPlayer])
            return
        }
        const timeout = setTimeout(() => {
            searchPlayers(displayValue);
        }, 400);
        return () => clearTimeout(timeout);
    }, [displayValue]);

    // Подставляем ФИО по value, только если пользователь не печатает
    useEffect(() => {
        if (isTyping) return;
        if (value === "-1") {
            setDisplayValue(unregPlayer.fio);
            return;
        }
        if (!value || isNaN(value)) return;
        const fetchPlayer = async () => {
            try {
                const result = await getPlayerById(parseInt(value));
                const res = result.data;
                if (Array.isArray(res) && res.length) {
                    setDisplayValue(res[0].fio + " | ID: " + res[0].id.toString().padStart(4,'0'));
                } else {
                    setDisplayValue(value.toString());
                }
            } catch {
                setDisplayValue(value.toString());
            }
        };
        fetchPlayer();
    }, [value, isTyping]);

    const handleSelect = (player) => {
        if (player.id === -1) {
            setDisplayValue(unregPlayer.fio);
        }else{
            setDisplayValue(`${player.fio} | ID: ${player.id.toString().padStart(4,'0')}`);
        }
        setIsTyping(false);
        setIsOpen(false);

        onChange(player.id.toString());
    };

    return (
        <div className={styles.inputWrapper} ref={wrapperRef}>
            <input
                type="text"
                placeholder="ID"
                value={displayValue}
                onChange={(e) => {
                    const val = e.target.value;
                    setDisplayValue(val);
                    setIsTyping(true);
                    if (!isNaN(val) && val.trim()) {
                        onChange(val.trim());
                    } else {
                        onChange("");
                    }
                }}
                onBlur={() => setIsTyping(false)}
                onFocus={() => {
                    if (searchResults.length) setIsOpen(true);
                }}
                className={`input ${styles.inputWithIcon}`}
            />
            <span
                className={styles.inputIcon}
                onClick={onRemove}
                style={{ cursor: "pointer" }}
            >
                <img src={cross} alt="Удалить" />
            </span>

            {isOpen && searchResults.length > 0 && (
                <div className={styles.dropdown}>
                    {searchResults.map((player) => (
                        <div
                            key={player.id}
                            className={styles.dropdownItem}
                            onClick={() => handleSelect(player)}
                        >
                        <p className={`body`}>
                            {
                                player.id === -1
                                ? unregPlayer.fio
                                : player.fio + ` | ID: ${player.id.toString().padStart(4,'0')}`
                            }
                        </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
